(function () {
  "use strict";

  // Content must never depend on JS to become visible. If GSAP fails to load,
  // is blocked, or the user prefers reduced motion, everything stays as
  // authored rather than stranded at opacity 0.
  var prefersReducedMotion =
    window.matchMedia &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function initScrollReveal() {
    if (!window.gsap || !window.ScrollTrigger) return;

    // Tell CSS the animation layer is live, so it stops force-showing
    // elements and lets GSAP own their opacity/transform.
    document.documentElement.classList.add("fk-anim-ready");

    var animations = {
      "fade-up": { y: 56, opacity: 0 },
      "slide-left": { x: -70, opacity: 0 },
      "slide-right": { x: 70, opacity: 0 },
      "scale-up": { scale: 0.9, opacity: 0 },
      "clip-reveal": { clipPath: "inset(100% 0 0 0)", opacity: 0 },
    };

    document.querySelectorAll("[data-reveal]").forEach(function (section) {
      var type = section.dataset.reveal || "fade-up";
      var from = animations[type] || animations["fade-up"];
      var targets = section.querySelectorAll("[data-reveal-item]");
      var list = targets.length ? targets : [section];

      var vars = Object.assign({}, from, {
        duration: 1,
        ease: type === "clip-reveal" ? "power4.inOut" : "power3.out",
        stagger: 0.1,
        scrollTrigger: {
          trigger: section,
          start: "top 90%",
          // Play once and stay put. "reverse" re-hid sections when scrolling
          // up, which read as content randomly disappearing.
          toggleActions: "play none none none",
          // If a section is already past the viewport on load (or the trigger
          // never fires), clear the inline styles so it is simply visible.
          once: true,
        },
        // Guarantee the end state even if ScrollTrigger is refreshed oddly.
        clearProps: "clipPath",
      });

      gsap.from(list, vars);
    });

    // Late-loading images change page height; without this, triggers compute
    // against stale offsets and sections below the fold never reveal.
    window.addEventListener("load", function () {
      window.ScrollTrigger.refresh();
    });
  }

  function start() {
    if (prefersReducedMotion) return;
    initScrollReveal();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();
